<template>
  <div class="page">
    <van-nav-bar
      title="我的报修"
      left-arrow
      @click-left="onClickLeft"
      fixed
      placeholder
    />
    <div class="dropdown-menu-div">
      <van-dropdown-menu>
        <!--<van-dropdown-item v-model="value1" :options="option1" @change="getRepairList()"/>-->
        <van-dropdown-item v-model="value2" :options="option2" @change="getRepairList()"/>
        <van-dropdown-item v-model="value3" :options="option3" @change="getRepairList()"/>
      </van-dropdown-menu>
    </div>
    <div class="body-div">
      <div class="card-div" v-for="(item, index) in repairList" :key="index" @click="toRepairDetail(item)">
        <div class="row-div">
          <div class="title-div">
            <img src="../../assets/bao-xiu/repair.png" width="17px">
            维修
          </div>
          <div class="status-div" :class="item.status == '未完成' ? 'orange' : item.status == '已完成' ? 'green' : 'blue'">
            <span class="status-span">·</span>
            {{item.repairState}}
          </div>
        </div>
        <div class="type-div">{{item.repairTypeChina}}</div>
        <div class="row-div service-number-div">
          <div class="left-cell">服务编号：{{item.serviceNumber}}</div>
          <div class="right-cell">{{item.createDate}}</div>
        </div>
      </div>
      <van-empty description="暂无记录" v-if="isEmpty"/>
    </div>
  </div>
</template>

<script>
  import { query } from '../../api/repair'
  import { getUserGasList } from '../../api/accountNumberManagement'

  export default {
    name: 'MyRepair',
    data () {
      return {
        value1: '全部', // 筛选条件-户号
        value2: 'all', // 筛选条件-报修类型
        value3: '1', // 筛选条件-时间
        option1: [{
          text: '全部',
          value: '全部'
        }], // 户号列表
        option2: [
          {
            text: '全部',
            value: 'all'
          },
          {
            text: '管道阀门报修',
            value: 'BG_GAS_PIPE'
          },
          {
            text: '燃气表报修',
            value: 'BG_GAS_METER'
          },
          {
            text: '燃气具报修',
            value: 'BG_GAS_STOVE'
          },
          {
            text: '拆改迁',
            value: 'BG_GAS_MODIFY'
          },
          {
            text: '其他报修',
            value: 'BG_GAS_OTHER'
          }
        ], // 报修类型列表
        option3: [
          {
            text: '最近1个月',
            value: '1'
          },
          {
            text: '最近3个月',
            value: '3'
          },
          {
            text: '最近1年',
            value: '12'
          }
        ], // 时间列表
        repairList: [], // 报修列表
        isEmpty: false, // 是否显示空状态
        gasAccountInfo: {} // 户号信息
      }
    },
    mounted () {
      if (this.$route.params.gasAccountInfo) {
        this.gasAccountInfo = this.$route.params.gasAccountInfo
        window.localStorage.gasAccountInfo = JSON.stringify(this.$route.params.gasAccountInfo)
      } else {
        this.gasAccountInfo = JSON.parse(window.localStorage.gasAccountInfo)
      }
      // this.getNumberList()
      this.getRepairList()
    },
    methods: {
      // 返回
      onClickLeft () {
        this.$router.go(-1)
      },

      // 跳转到报修及巡检详情页面
      toRepairDetail (item) {
        this.$router.push({
          name: 'RepairDetail',
          params: { detail: item }
        })
      },

      // 获取报修列表
      getRepairList () {
        let that = this
        that.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0
        })
        const params = {
          appContactId: JSON.parse(window.localStorage.userInfo).appContactId ? JSON.parse(window.localStorage.userInfo).appContactId : '',
          userId: JSON.parse(window.localStorage.userInfo).id,
          // gasUserNumber: (that.value1 === '全部') ? 'all' : that.value1,
          gasUserNumber: that.gasAccountInfo.gasAccount,
          type: that.value2,
          time: that.value3,
          userNote: 'Bjtong',
          dataSource: 'Bjtong'
        }
        query(params).then(res => {
          if (res.data.success) {
            that.repairList = []
            that.isEmpty = false
            if (res.data.rows.length > 0) {
              for (let i = 0; i < res.data.rows.length; i++) {
                that.repairList.push(res.data.rows[i])
              }
            } else {
              that.isEmpty = true
            }
            that.$toast.clear()
          } else {
            that.$toast.fail(res.data.message)
            that.repairList = []
            that.isEmpty = true
          }
        }).catch(() => {
          that.$toast.fail('查询失败')
        })
      },

      // 获取用户绑定的燃气号列表
      getNumberList () {
        let that = this
        const params = {
          userId: JSON.parse(window.localStorage.userInfo).id
        }
        getUserGasList(params).then(res => {
          if (res.data.success) {
            that.option1 = [{
              text: '全部',
              value: '全部'
            }]
            for (let i = 0; i < res.data.rows.length; i++) {
              that.option1.push({
                text: res.data.rows[i].label + '：' + res.data.rows[i].userCode,
                value: res.data.rows[i].userCode
              })
            }
          } else {
            that.$toast.fail((res.data.message ? res.data.message : '获取用户编号异常'))
          }
        }).catch(() => {
          that.$toast.fail('获取用户编号异常')
        })
      }
    }
  }
</script>

<style scoped>
  .page {
    background: #F7F8FA;
    width: 100%;
  }

  .body-div {
    padding: 0 4% 35px 4%;
    margin-top: 60px;
  }

  .row-div {
    display: flex;
    align-items: center;
  }

  .card-div {
    background: #FFF;
    border-radius: 8px;
    padding: 17px;
    margin-top: 15px;
  }

  .title-div {
    width: 60%;
    font-size: 19px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 26px;
    color: #27282E;
    text-align: left;
  }

  .status-div {
    width: 40%;
    font-size: 17px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 23px;
    text-align: right;
  }

  .type-div {
    font-size: 17px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 23px;
    color: #27282E;
    margin: 12px 0 6px 0;
  }

  .service-number-div {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 19px;
    color: #999999;
  }

  .left-cell {
    width: 60%;
    text-align: left;
  }

  .right-cell {
    width: 40%;
    text-align: right;
  }

  .status-span {
    font-weight: bold;
    margin-right: 6px;
  }

  .orange {
    color: #FF6B38;
  }

  .green {
    color: #00AE8D;
  }

  .blue {
    color: #005AE3;
  }

  .dropdown-menu-div {
    position: fixed;
    width: 100%;
  }
</style>
